/*  ========================================================================
    # Scripts - Video Handler
    ========================================================================  */

/**
 * Handle custom video control for video section
 */
const VideoHandler = {
  cfg: {
    videoContainer: document.querySelectorAll('.s-video__wrapper')
  },

  handleCustomVideoControl() {
    this.cfg.videoContainer.forEach(container => {
      const video = container.querySelector('.s-video__video');
      const customPlayButton = container.querySelector('.c-button');
      if (customPlayButton)
        customPlayButton.addEventListener('click', () => {
          video.controls = true;
          video.play();
          customPlayButton.style.opacity = 0;
          customPlayButton.style.visibility = 'hidden';
        });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.videoContainer?.length > 0) {
      this.handleCustomVideoControl();
    }
  }
};

export default VideoHandler;
